(function(Utilities) {
	'use strict';

	function DcyNavigationManagerStatus(dcyUtilsFactory, dcyNavigationManagerUtilsFactory) {

		/**@PRIVATE
		 * Inflates NodeInfo passed
		 * @param nodeId {string} node identifier
		 * @param nodeValue {object} node details
		 */
		var 

		MD_CTX_DEFAULT = {
			draggableFiles		: true,
			droppableFiles		: false,
			draggableFolders	: true,
			droppableFolders	: true
		},
		
		setMDAttribute = function(attrName, defaultValue, node){
			switch (attrName) {
				case 'droppable':
					if(_.isEqual(node.type, RESOUCE_TYPE_SUPPORTED.SPECIAL_FOLDER)){
						node.nodeInfo[attrName] = false;
					}
					else{
						node.nodeInfo[attrName] = (!Utilities.isUndefinedOrNull(node.nodeInfo[attrName]) ? node.nodeInfo[attrName] : defaultValue);
					}
					break;
				case 'draggable':
					if(_.isEqual(node.type, RESOUCE_TYPE_SUPPORTED.ROOT) || _.isEqual(node.type, RESOUCE_TYPE_SUPPORTED.SPECIAL_FOLDER)){
						node.nodeInfo[attrName] = false;
					}
					else{
						node.nodeInfo[attrName] = (!Utilities.isUndefinedOrNull(node.nodeInfo[attrName]) ? node.nodeInfo[attrName] : defaultValue);
					}
					break;

				default:
					node.nodeInfo[attrName] = !Utilities.isUndefinedOrNull(node.nodeInfo[attrName]) ? node.nodeInfo[attrName] : defaultValue;
					break;
			}
		},
		
		inflateFolderInfos = function(node, ctx){
			setMDAttribute('expanded', false, node);
			setMDAttribute('visited', false, node);
			setMDAttribute('checked', false, node);
			setMDAttribute('draggable', ctx.draggableFolders, node);
			setMDAttribute('droppable', ctx.droppableFolders, node);
		}, 

		inflateFileInfos = function(node, ctx){
			setMDAttribute('opened', false, node);
			setMDAttribute('draggable', ctx.draggableFiles, node);
			setMDAttribute('droppable', ctx.droppableFiles, node);
		},

		inflateCommonInfos = function(node, ctx){
			setMDAttribute('selected', false, node);
			setMDAttribute('visible', true, node);
		},

		inflatesNodeInfos = function(node, parentNode, ctx) {
			//Node passed is a folder and set expanded, visited, draggable and droppable state
			if (isFolder(node.type)){
				inflateFolderInfos(node, ctx);
			}
			//Node passed is a file and set only opened state
			else {
				inflateFileInfos(node, ctx);
			}

			//Set generic states				
			node.nodeInfo.filter 			= parentNode && parentNode.nodeInfo ? parentNode.nodeInfo.filter+'.nodes.'+node.id : 'root';

			inflateCommonInfos(node, ctx);
		},
		/**@PRIVATE
		 * Remove Node in '*' Status mode
		 * @param arrayToManage {string}
		 * @param nodeTypeToManage {String}
		 * @param status {Boolean}
		 */
		removeStatusNodes = function(nodes, nodeTypeToManage, status){
			_.forEach(nodes, function(node){
				var isIncludeNode = true;
				if(dcyUtilsFactory.isValidArray(nodeTypeToManage)){
					isIncludeNode = _.findIndex(nodeTypeToManage, function(type) { return type == node.type; });
				}
				if(isIncludeNode || isIncludeNode >= 0){
					node.nodeInfo[status] = false;
				}	
			});
		},
		/**
		 * Adds all child nodes into the nodes map specifying its parent node
		 * @param parentNode {object} parent node
		 */
		inflateParentNodeInfos = function(parentNode, ctx) {
			var nodes = parentNode.nodes;
			angular.forEach(nodes, function(node, nodeKey) {
				inflatesNodeInfos(node, parentNode, ctx);
				inflateParentNodeInfos(node, ctx);
			});
		},
		/**
		 * Return resources in particular status value (Recursive routine)
		 * @param modelData {object}
		 * @param statusKey {string} status type for example 'selected/opened ...'
		 * @param statusValue {string/boolean} value for status type
		 * @returns {object} nodeInfo
		 */
		getStatusNode = function(modelData, statusKey, statusValue){
			var grapped = new Array(),
				data = modelData.root ? modelData.root : modelData;
			
			var isValidNodeByKeys = (node, statusKeys, statusValue) => {
				var isValid = false;
				
				_.forEach(_.flatten([statusKey]), key => {
					isValid = isValid || (_.get(node, key) == statusValue);
				});
				
				return isValid;
			};
			
			if(data){
				var fn = function(data){
					var filtering =  _.filter(data.nodes, function(node){
						if(node.nodes){
							fn(node, statusKey, statusValue);
						}
						return isValidNodeByKeys(node, statusKey, statusValue);
					});
					if(filtering.length){
						grapped.unshift.apply(grapped, filtering);
					}
				};
				
				fn(data);
			}
			
			if(isValidNodeByKeys(data, statusKey, statusValue)){
				grapped.unshift(data);
			}
			
			if(grapped.length){
				return grapped;
			}
		},
		/**@Private
		 * define nodeMap object
		 * @type {Object}
		 */
		isFolder 				= dcyNavigationManagerUtilsFactory.isFolder,
		isFile 					= dcyNavigationManagerUtilsFactory.isFile,
		RESOUCE_TYPE_SUPPORTED	= dcyNavigationManagerUtilsFactory.getResourceTypeSupported();

		/**
		 * Gets the nodes from the nodes map (by id)
		 * @param nodeId {string} node identifier
		 * @returns {array of object}
		 */
		function getDeepNodesByIdAndFolderId(modelData, nodeId, folderId) {
			nodeId = angular.equals(nodeId, 'root') ? RESOUCE_TYPE_SUPPORTED.ROOT : nodeId;
			var grappedNode = getStatusNode(modelData, ['nodeInfo.id', 'id'] , nodeId);
			
			if(grappedNode && grappedNode.length){
				var filtered = folderId ? _.filter(grappedNode, ['parentId', folderId]) : grappedNode;
				return filtered[0];
			}
			return null;
		}
		
		/**
		 * Gets the first node from the nodes map (by id)
		 * @param nodeId {string} node identifier
		 * @returns {object}
		 */
		function getDeepNodeById(modelData, nodeId) {
			nodeId = angular.equals(nodeId, 'root') ? RESOUCE_TYPE_SUPPORTED.ROOT : nodeId;
			var grappedNode = getStatusNode(modelData, ['nodeInfo.id', 'id'], nodeId);
			
			if(grappedNode && grappedNode.length){
				return grappedNode[0];
			}
			return null;
		}
		/**
		 * Return folder in selected status of a specific folder node [ONLY FOLDER]
		 * @param nodeId {string} node identifier
		 * @returns folder selected {object} or null
		 */
		function getFolderSelected(modelData, nodeId) {
			var node = getDeepNodeById(modelData, nodeId);
			var nodeInfo = node ? node.nodeInfo : null;

			if(node && isFolder(node.type)){
				var selectedNodes = getSelected(modelData);
				return _.filter(selectedNodes, function(selectedNode){
					if(isFolder(selectedNode.type) && angular.equals(selectedNode.parentId, nodeInfo.id) && selectedNode.selected){
						return selectedNode;
					}
				});
			}
		}
		/**
		 * Return file in opened status of a specific folder node [ONLY FOLDER]
		 * @param nodeId {string} node identifier
		 * @returns file selected {object} or null
		 */
		function getResourceOpened(modelData, nodeId) {
			var node = getDeepNodeById(modelData, nodeId);
			var nodeInfo = node ? node.nodeInfo : null;
			if(nodeInfo && isFolder(node.type)){
				var openedNodes = getOpened(modelData);
				return _.filter(openedNodes, function(openedNode){
					if(isFile(openedNode.type) && nodeInfo.filter.match(nodeInfo.filter) && nodeInfo.opened){
						return nodeInfo;
					}
				});
			}
		}
		/**
		 * Return all opened nodes
		 * @returns {array} selected nodes 
		 */
		function getOpened(modelData) {
			var opened = getStatusNode(modelData, 'nodeInfo.opened', true);
			return opened;
		}
		/**
		 * Return all selected nodes
		 * @returns {array} selected nodes 
		 */
		function getSelected(modelData) {
			var selected = getStatusNode(modelData, 'nodeInfo.selected', true);
			return selected;
		}
		/**
		 * Return all selected nodes
		 * @returns {array} selected nodes 
		 */
		function getChecked(modelData) {
			var checked = getStatusNode(modelData, 'nodeInfo.checked', true);
			return checked;
		}

		/**
		 * Return all expanded nodes
		 * @returns {array} expanded nodes 
		 */
		function getExpanded(modelData) {
			var expanded =  getStatusNode(modelData, 'nodeInfo.expanded', true);
			return expanded;
		}
		
		/**
		 * Return all expanded nodes
		 * @returns {array} expanded nodes 
		 */
		function getVisited(modelData) {
			var visited =  getStatusNode(modelData, 'nodeInfo.visited', true);
			return visited;
		}

		/**
		 * Sets the draggable status on specific node and relative children
		 * @param nodeId {string} node identifier
		 * @param draggable {boolean} if the folder is draggable
		 */
		function setDraggableRecursively(modelData, nodeId, isDraggable){
			if(Utilities.isUndefinedOrNull(nodeId)){
				return;
			}
			var node = getDeepNodeById(modelData, nodeId);
			var nodeInfo = node ? node.nodeInfo : null;
			if (nodeInfo) {
				nodeInfo.draggable = isDraggable;
				var childrenNode = _.get(modelData, nodeInfo.filter).nodes;
				if(childrenNode){
					_.forEach(childrenNode, function(node, key){
						setDraggableRecursively(modelData, node.nodeInfo.id, isDraggable);
					});
				}
			}
		}
		/**
		 * Sets the droppable status on specific node and relative folder children [ONLY FOLDER]
		 * @param nodeId {string} node identifier
		 * @param droppable {boolean} if the folder is droppable
		 */
		function setEscalationExpandedRecursively(modelData, nodeId, isExpanded){
			var node = getDeepNodeById(modelData, nodeId);
			var nodeInfo = node ? node.nodeInfo : null;
			if (nodeInfo) {
				if(isFolder(node.type)){
					nodeInfo.expanded = isExpanded;
				}
				var parentId = nodeInfo.parentId || node.parentId;
				if(parentId != '-1' && angular.isDefined(parentId)){
					setEscalationExpandedRecursively(modelData, parentId, isExpanded);
				}
			}
		}
		
		/**
		 * Sets the checked status on specific node and relative folder children
		 * @param element 
		 * @param isChecked {boolean} if the folder is droppable
		 */
		function setCheckedRecursively(element, isChecked){
			var nodeInfo = element.nodeInfo;
			if (nodeInfo) {
				nodeInfo.checked = isChecked;
				var childrenNode = element.nodes;
				if(childrenNode){
					_.forEach(childrenNode, function(node, key){
						setCheckedRecursively(node, isChecked);
					});
				}
			}
		}
		/**
		 * Sets key, value recursively on specific node and relative folder children
		 * @param element 
		 * @param settings {object} = keyToSet {string} , valueToSet {any}  
		 */
		function setRecursively(element, options){
			var nodeInfo = element.nodeInfo;
			if (nodeInfo) {
				_.each(options, option => {
					nodeInfo[option.keyToSet] = option.valueToSet;
				});
				var childrenNode = element.nodes;
				if(childrenNode){
					_.forEach(childrenNode, function(node, key){
						setRecursively(node, options);
					});
				}
			}
		}
		
		var _isElementViewable = (element) => {
			return _.filter(element.nodes, node => {
				if(node.nodes){
					_isElementViewable(node);
				}
				return node.nodeInfo.visible || Utilities.isUndefinedOrNull(node.nodeInfo.visible); 
			});
		};
		
		//searchText to false for reset all status 
		function filterRecursively(element, searchText){ 
			var nodeInfo = element.nodeInfo;
			
			if (nodeInfo) {
				if(isFile(element.type)){
					if(Utilities.isValidString(searchText) ){
						let isMatch = _.includes(element.nodeInfo.name.toLowerCase(), searchText.toLowerCase());
						element.nodeInfo.visible = isMatch ? true : false;
						element.nodeInfo.isMatch = isMatch ? true : false;
					}
					else{
						element.nodeInfo.visible = true;
						element.nodeInfo.isMatch = false;
					}
				}
				else {
					if(searchText != false){
						let isToShown = _.includes(element.nodeInfo.name.toLowerCase(), searchText.toLowerCase()) || _isElementViewable(element).length;
						element.nodeInfo.visible = isToShown;
						element.nodeInfo.storedExpanded = !Utilities.isUndefinedOrNull(element.nodeInfo.storedExpanded) ? element.nodeInfo.storedExpanded : element.nodeInfo.expanded;
						element.nodeInfo.expanded = true;
					}
					else {
						element.nodeInfo.visible = true;
						let storedExpanded = element.nodeInfo.storedExpanded;
						element.nodeInfo.expanded = !Utilities.isUndefinedOrNull(storedExpanded) ? storedExpanded : element.nodeInfo.expanded;
						delete element.nodeInfo.storedExpanded;
					}
				}
				
				var childrenNode = element.nodes;

				if(childrenNode){
					_.forEach(childrenNode, function(node, key){
						filterRecursively(node, searchText);
					});
				}
			}
		}
		
		/**
		 * Sets the inError status on specific node and relative folder children [ONLY FOLDER]
		 * @param nodeId {string} node identifier
		 * @param droppable {boolean} if the folder is droppable
		 */
		function setEscalationErrorRecursively(modelData){
			var nodeInfo = modelData.nodeInfo;
			if (modelData && isFolder(modelData.type)) {
				var isNotRootFolder = nodeInfo.parentId != '-1' && angular.isDefined(nodeInfo.parentId);
				
				if(isNotRootFolder){
					nodeInfo.inError  = nodeInfo.error ? true : false;
					
					var childrenInError = getStatusNode(modelData, 'inError', true);
					
					var filtering =  _.filter(childrenInError, function(node){
						return node.nodeInfo.parentId == nodeInfo.id;
					});
					
					nodeInfo.childrenInError =  filtering.length ? true : false;
				}
			}
		}
		/**
		 * Sets the droppable status on specific node and relative folder children [ONLY FOLDER]
		 * @param nodeId {string} node identifier
		 * @param droppable {boolean} if the folder is droppable
		 */
		function setDroppableRecursively(modelData, nodeId, isDroppable){
			if(Utilities.isUndefinedOrNull(nodeId)){
				return;
			}
			var node = getDeepNodeById(modelData, nodeId);
			var nodeInfo = node ? node.nodeInfo : null;
			if (node && isFolder(node.type)) {
				nodeInfo.droppable = isDroppable;
				var childrenNode = _.get(modelData, nodeInfo.filter).nodes;
				if(childrenNode){
					_.forEach(childrenNode, function(node, key){
						setDroppableRecursively(modelData, node.nodeInfo.id, isDroppable);
					});
				}
			}
		}
		/**
		 * Removes children node in selected status relatively nodeId passed or type based [ONLY FOLDER]
		 * @param nodeId {string} node identifier
		 * @param nodeTypeToRemove {string} node type to manage
		 */
		function removeSelected(modelData, nodeId, nodeTypeToRemove) {
			nodeTypeToRemove = angular.isString(nodeTypeToRemove) ? [nodeTypeToRemove] : nodeTypeToRemove;
			var selectedNodes = getSelected(modelData);
			
			if(!nodeId){
				removeStatusNodes(selectedNodes, nodeTypeToRemove, 'selected');
			}
			else{
				var node = getDeepNodeById(modelData, nodeId);
				var nodeInfo = node ? node.nodeInfo : null;
				if(node && isFolder(node.type)){
					_.forEach(selectedNodes, function(selectedNode){
						if(dcyUtilsFactory.isUndefinedOrNull(nodeTypeToRemove) || angular.equals(selectedNode.type, nodeTypeToRemove)){
							var selNodeInfo = selectedNode.nodeInfo;
							var matches;
							//Indietro
							if(selNodeInfo.filter.length > nodeInfo.filter.length){
								matches = selNodeInfo.filter.match(nodeInfo.filter);
							}
							//Avanti
							else if(selNodeInfo.filter.length < nodeInfo.filter.length){
								matches = nodeInfo.filter.match(selNodeInfo.filter);
							}
							//Restiamo sullo stesso path
							else if(selNodeInfo.filter.length === nodeInfo.filter.length){
								matches = false;
							}

							if(matches){
								selNodeInfo.selected = false;
							}
						}
					});
				}
			}
		}
		
		function removeVisited(modelData, nodeId, nodeTypeToRemove) {
			nodeTypeToRemove = angular.isString(nodeTypeToRemove) ? [nodeTypeToRemove] : nodeTypeToRemove;
			var visitedNodes = getVisited(modelData);
			
			if(!nodeId){
				removeStatusNodes(visitedNodes, null, 'visited');
			}
			else{
				var node = getDeepNodeById(modelData, nodeId);
				var nodeInfo = node ? node.nodeInfo : null;
				if(node && isFolder(node.type)){
					_.forEach(visitedNodes, function(visitedNode){
						if(dcyUtilsFactory.isUndefinedOrNull(nodeTypeToRemove) || angular.equals(visitedNode.type, nodeTypeToRemove)){
							var matches;
							//Indietro
							if(visitedNode.filter.length > nodeInfo.filter.length){
								matches = visitedNode.filter.match(nodeInfo.filter);
							}
							//Avanti
							else if(visitedNode.filter.length < nodeInfo.filter.length){
								matches = nodeInfo.filter.match(visitedNode.filter);
							}
							//Restiamo sullo stesso path
							else if(visitedNode.filter.length === nodeInfo.filter.length){
								matches = false;
							}

							if(matches){
								visitedNode.visited = false;
							}
						}
					});
				}
			}
		}
		/**
		 * Removes all nodes in expanded status [ONLY FOLDER]
		 */
		function removeExpanded(modelData) {
			removeStatusNodes(getExpanded(modelData), null, 'expanded');
		}
		
		/**
		 * Initial nodes registration process.
		 * Starting from the root, it records all child nodes on the nodes map
		 */
		function initialize(modelData, mdCtxOptions) {
			if(!dcyUtilsFactory.isValidObject(modelData)){
				return false;
			}
			
			var rootNode = modelData.root ? modelData.root : modelData;
			rootNode.nodeInfo.expanded = true;	
			let ctx = _.assign({}, MD_CTX_DEFAULT, mdCtxOptions || {});
			inflatesNodeInfos(rootNode, null, ctx);
			inflateParentNodeInfos(rootNode, ctx);
		}
		/**
		 * update status manager
		 */
		function update(modelData, ctx){
			initialize(modelData, ctx);
		}

		function getNodeByType(modelData, type){
			return _.find(modelData, ['type', type]);
		}

		return {
			initialize 							: initialize,
			update	 							: update,
			getDeepNodeById 					: getDeepNodeById,
			getNodeByType 						: getNodeByType,
			getSelected 						: getSelected,
			getChecked 							: getChecked,
			getResourceOpened 					: getResourceOpened,
			removeSelected	 					: removeSelected,
			removeExpanded						: removeExpanded,
			removeVisited						: removeVisited,
			setDroppableRecursively				: setDroppableRecursively,
			setDraggableRecursively				: setDraggableRecursively,
			setEscalationExpandedRecursively	: setEscalationExpandedRecursively,
			setEscalationErrorRecursively		: setEscalationErrorRecursively,
			setCheckedRecursively				: setCheckedRecursively,
			setRecursively						: setRecursively,
			getFolderSelected 					: getFolderSelected,
			getExpanded 						: getExpanded,
			getDeepNodesByIdAndFolderId			: getDeepNodesByIdAndFolderId,
			filterRecursively					: filterRecursively
		};
	}

	DcyNavigationManagerStatus.$inject = ['dcyUtilsFactory', 'dcyNavigationManagerUtilsFactory'];

	angular
	.module('dcyApp')
	.register
	.factory('dcyNavigationManagerStatusFactory', DcyNavigationManagerStatus);


}(window.Utilities));
